import { Switch as AriaSwitch, SwitchProps as AriaSwitchProps } from 'react-aria-components';
import { cn } from '~/lib/utils';

export interface SwitchProps extends AriaSwitchProps {
  className?: string;
  label?: string;
  description?: string;
}

export default function Switch({
  label,
  description,
  className,
  isSelected,
  ...props
}: SwitchProps) {
  return (
    <AriaSwitch
      className={cn(
        'group inline-flex items-center gap-3 cursor-pointer select-none',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-input-border-focused',
        className,
      )}
      isSelected={isSelected}
      {...props}
    >
      {label || description ? (
        <div className="flex min-w-0 flex-1 flex-col">
          {label && <div className="text-[13px] text-foreground">{label}</div>}
          {description && <div className="text-xs text-body/75">{description}</div>}
        </div>
      ) : null}
      <div className="relative h-6 w-10 shrink-0">
        <span
          className={cn(
            'block w-full h-full rounded-full transition-colors duration-200',
            'bg-switch-track',
            'group-data-selected:bg-switch-track-selected',
          )}
        />

        <span
          className={cn(
            'absolute top-1/2 left-0.5 -translate-y-1/2 size-5 rounded-full transition-transform duration-200',
            'bg-switch-thumb',
            'group-data-selected:translate-x-4 group-data-selected:bg-switch-thumb-selected',
          )}
        />
      </div>
    </AriaSwitch>
  );
}
